import Vue from 'vue';
import Component from 'vue-class-component';

import { DesignerStateProvider } from '../../designer.provider';
import { Inject, Watch } from 'vue-property-decorator';
import { DesignerElementTypes, DesignerToolNames } from '../../designer.enum';

@Component({})
export default class EdDesignerElementsToolsItemBackgroundComponent extends Vue {
  readonly toolName = DesignerToolNames.BackgroundElement;

  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;

  isOpened = false;
  color: string = '#F5F5F5';

  get isDisabled(): boolean {
    return ![
      DesignerElementTypes.Rectangle
    ].includes(this.DesignerStateProvider?.elementSelected?.type);
  }

  toggleColorPicker() {
    this.isOpened = !this.isOpened;
  }

  onColorUpdated() {
    this.DesignerStateProvider.elementSelected.setBackgroundColor(this.color);
  }
}